import { defineMessages } from 'react-intl';

export default defineMessages({
  productsTitlePage: {
    id: 'view.myaccount.step.homePage.productsTitlePage',
    defaultMessage: 'Products',
  },
  addProduct: {
    id: 'components.myaccount.homePage.productItem.addProduct',
    defaultMessage: 'Add a product',
  },
  searchProductPlaceholder: {
    id: 'components.myaccount.homePage.productItem.searchProductPlaceholder',
    defaultMessage: "Product's name, reference, ...",
  },
  addProductSubmit: {
    id: 'components.myaccount.homePage.productItem.addProductSubmit',
    defaultMessage: 'Add',
  },
});
